import { Globe2, Network, ScanSearch, UserRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { AgentCore, ConnectionLines, GraphicCard, IllustrationFrame } from './shared'

function ResearchTarget({ label }: { label: string }) {
  return (
    <g>
      <circle cx="140" cy="145" r="89" className="fill-none stroke-primary/10" />
      <circle
        cx="140"
        cy="145"
        r="68"
        className="fill-none stroke-primary/20"
        strokeDasharray="4 7"
      />
      <rect
        x="79"
        y="78"
        width="122"
        height="137"
        rx="16"
        className="fill-card stroke-primary/40"
      />
      <circle cx="140" cy="121" r="25" className="fill-primary/10" />
      <UserRound x="128" y="109" width="24" height="24" className="text-primary-strong" />
      <text x="140" y="170" textAnchor="middle" className="fill-foreground text-xs font-semibold">
        {label}
      </text>
      <path
        d="M111 188H169"
        className="stroke-muted-foreground/20"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle cx="69" cy="91" r="5" className="fill-primary/50" />
      <circle cx="210" cy="201" r="5" className="fill-primary/50" />
    </g>
  )
}

export function OsintAgentIllustration() {
  const { t } = useTranslation()
  const key = 'whatsNew.slides.osintAgent.graphic'
  return (
    <IllustrationFrame label={t(`${key}.description`)}>
      <ConnectionLines d="M201 145H285 M351 145H392Q405 145 405 127V62H444 M405 127V155H466 M405 155V237H417" />
      <ResearchTarget label={t(`${key}.subject`)} />
      <AgentCore label={t('whatsNew.slides.osintAgent.label')} />
      <GraphicCard card={{ x: 444, y: 33, label: t(`${key}.sources`), icon: Globe2 }} />
      <GraphicCard card={{ x: 466, y: 126, label: t(`${key}.connections`), icon: Network }} />
      <GraphicCard card={{ x: 417, y: 207, label: t(`${key}.findings`), icon: ScanSearch }} />
      <circle cx="405" cy="127" r="4" className="fill-primary" />
    </IllustrationFrame>
  )
}
